/* eslint-disable @typescript-eslint/no-explicit-any */
import { FunctionComponent } from 'react';
import './styles/Chip.scss';

import { Chip as MuiChip, Tooltip as MuiTooltip } from '@mui/material';

import { TColor } from '@dw/models/shared';
import { classNames, componentClassName } from '@dw/utils';

interface IChipProps {
  label?: string;
  icon?: React.ReactNode;
  size?: 'small' | 'medium';
  color?: TColor;
  tooltip?: string;
  onClick?: () => void;
  className?: string;
  variant?: 'outlined' | 'filled';
}
export const Chip: FunctionComponent<IChipProps> = (props: IChipProps) => {

  const {
    label,
    icon,
    size,
    color,
    tooltip,
    onClick,
    className,
    variant
  } = props;

  const cn = componentClassName('chip');

  return (
    <MuiTooltip title={tooltip}>
      <MuiChip
        label={label}
        icon={icon as any}
        size={size}
        color={color}
        onClick={onClick}
        variant={variant}
        className={classNames(className, cn('size', size ?? 'medium'), {
          [cn('icon-only')]: !!icon && !label
        })}
      />
    </MuiTooltip>
  )
}